(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/video-player/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/video-player/assets/javascripts/prescript.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};
  svs.components.video_player = svs.components.video_player || {};
})(svs);

 })(window);